import { css } from "lit-element";

// language=CSS
export const style = css`
	:host {
		display: flex;
	}

	.side-menu {
		max-width: 80px;
		background-color: var(--sidebar-bg);
		font-size: var(--sidebar-simple-font-size, 14px);

		border-right: 1px solid transparent;
        overflow: hidden;
        transition: max-width 100ms ease-in 200ms;
	}
    
    .side-menu:hover {
        max-width: 250px;
    }


    .side-menu[active] {
		margin: 0;
	}

	.side-menu-logo {
		padding: 0;
		min-width: 100%;
		margin: auto;
		height: auto;
        min-height: 80px;
		background-color: var(--logo-bg);
	}
    
    .side-menu-items {
        height: 100%;
        margin: var(--sidebar-simple-menu-items-margin, 0);
    }
    
	.side-menu-logo img {
		display: block;
		max-width: 80px;
		max-height: 60px;
		margin: 10px;
        transition: all 300ms ease;
	}
    
    .side-menu:hover  .side-menu-logo img {
        max-height: 60px;
    }
    
	.side-menu-container {
		margin-top: 20px;
	}

	label {
		font-size: 12px;
		color: var(--sidebar-primary);
        margin-left: 20px;
        margin-right: auto;
		opacity: 1;
		letter-spacing: 0.05em;
	}
  
	.side-menu-item {
		position: relative;
		display: block;
		width: calc(100% - 100px);
		padding: 15px 40px 15px 80px;
		text-decoration: none;
		font-weight: normal;
		color: var(--sidebar-primary);
		opacity: 0.8;

        transition: padding 200ms ease-in-out 200ms;
	}
    
    .side-menu:hover .side-menu-item {
        padding: 15px 40px 15px 60px;
    }

    .side-menu-item:before {
		display: block;
		content: "";
		position: absolute;
		top: 0;
		left: -10px;
		margin-top: 10px;
		height: 50%;
		width: 5px;
		background-color: var(--sidebar-accent);

		border-radius: 0 5px 5px 0;

		box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.27);

		-moz-transition: all 200ms ease-in-out;
		-webkit-transition: all 200ms ease-in-out;
		-o-transition: all 200ms ease-in-out;
		transition: all 200ms ease-in-out;
	}

	.side-menu-item[selected],
	.side-menu-item:hover {
		opacity: 1;
		color: var(--sidebar-accent);
	}

	.side-menu-item[selected]:before,
	.side-menu-item:hover:before {
		left: 0;
	}

	.side-menu-item:hover ~ .side-menu-item[selected]:before {
		left: -10px;
	}

	.side-menu-item label {
		display: inline-block;
	}

	.side-menu-item[selected]:hover {
		opacity: 0.87;
	}

	sw-icon {
		position: absolute;
		left: 30px;
		top: 15px;
        width: 20px;
		margin: auto;
        --sw-icon-width: auto;
        --sw-icon-height: var(--sidebar-simple-icon-height, 16px);
		--sw-icon-color: var(--sidebar-primary);

		-moz-transition: all 200ms ease-in-out;
		-webkit-transition: all 200ms ease-in-out;
		-o-transition: all 200ms ease-in-out;
		transition: all 200ms ease-in-out;
	}

	.side-menu-item[selected] sw-icon,
	.side-menu-item:hover sw-icon {
		--sw-icon-color: var(--sidebar-accent);
	}

	.side-menu-item:hover ~ .side-menu-item[selected] sw-icon {
		--sw-icon-color: var(--sidebar-primary);
	}
`;
